(() => {
  "use strict";

  const mobileCastle = window.matchMedia("(max-width: 759px)");
  if (!mobileCastle.matches || window.__YIZCHO_CASTLE_APP_PORT_V01__) return;

  const castleAbout = document.querySelector("#castle-about");
  const castleExperience = document.querySelector("#castle-experience");
  const castleEntryStage = document.querySelector("#castle-entry-stage");
  const castleStudioStage = document.querySelector("#castle-studio-stage");
  const castleArtistStage = document.querySelector("#castle-artist-stage");
  const castleDoor = document.querySelector("#castle-door");
  const artistCompatibilityTrigger = document.querySelector("#castle-artwork-hotspot");
  const castleBack = document.querySelector("#castle-experience-back");
  const castleBackLabel = document.querySelector("#castle-experience-back-label");
  const castleClose = document.querySelector("#castle-experience-close");

  if (
    !castleExperience || !castleEntryStage || !castleStudioStage || !castleArtistStage ||
    !castleDoor || !artistCompatibilityTrigger
  ) return;

  const originalEntrySrc = castleExperience.dataset.castleMobileEntrySrc;
  const entrySrc = originalEntrySrc && new URL("yizcho-castle-entry-outpaint-20260916.png", new URL(originalEntrySrc, document.baseURI)).href;
  const studioSrc = castleExperience.dataset.castleMobileStudioSrc;
  const bubbleSrc = castleExperience.dataset.castleMobileBubbleSrc;
  if (!entrySrc || !studioSrc || !bubbleSrc) return;

  window.__YIZCHO_CASTLE_APP_PORT_V01__ = true;
  castleExperience.dataset.castleMobileApp = "true";
  const syncCastleViewport = () => {
    const viewport = window.visualViewport;
    // Let pinch zoom behave normally; it must not resize the illustration.
    if (viewport && Math.abs(viewport.scale - 1) > 0.01) return;
    castleExperience.style.setProperty("--castle-viewport-height", `${viewport?.height || window.innerHeight}px`);
    castleExperience.style.setProperty("--castle-viewport-top", `${viewport?.offsetTop || 0}px`);
  };
  let viewportFrame = 0;
  const scheduleCastleViewport = () => {
    cancelAnimationFrame(viewportFrame);
    viewportFrame = requestAnimationFrame(syncCastleViewport);
  };
  syncCastleViewport();
  window.addEventListener("resize", scheduleCastleViewport, { passive: true });
  window.visualViewport?.addEventListener("resize", scheduleCastleViewport, { passive: true });
  window.visualViewport?.addEventListener("scroll", scheduleCastleViewport, { passive: true });
  castleAbout?.setAttribute("aria-label", "Enter Yizcho Castle");

  const entryImage = castleEntryStage.querySelector(".castle-entry__canvas > img");
  if (entryImage) {
    entryImage.src = entrySrc;
    entryImage.removeAttribute("data-background-src");
    entryImage.setAttribute("width", "1024");
    entryImage.setAttribute("height", "1536");
    entryImage.alt = "A close view of Yizcho Castle with its wooden double doors at the top of the stone steps";
  }
  castleEntryStage.style.setProperty("--castle-entry-ambient-image", `url("${entrySrc}")`);
  castleDoor.setAttribute("aria-label", "Open the wooden double doors and enter Yizcho's studio");
  castleDoor.replaceChildren();

  const studioAmbient = document.createElement("div");
  studioAmbient.className = "castle-studio__ambient";
  studioAmbient.setAttribute("aria-hidden", "true");

  const studioCanvas = document.createElement("div");
  studioCanvas.className = "castle-studio__canvas";

  const studioImage = document.createElement("img");
  studioImage.src = studioSrc;
  studioImage.width = 852;
  studioImage.height = 1846;
  studioImage.alt = "Yizcho's sunlit artist studio with a wooden cat steward sitting beside the worktable";
  studioImage.draggable = false;

  const woodenCat = document.createElement("button");
  woodenCat.className = "castle-wooden-cat";
  woodenCat.id = "castle-wooden-cat";
  woodenCat.type = "button";
  woodenCat.setAttribute("aria-label", "Wooden cat steward");
  woodenCat.setAttribute("aria-haspopup", "dialog");
  woodenCat.setAttribute("aria-controls", "castle-guide-dialogue");
  woodenCat.setAttribute("aria-expanded", "false");

  const guide = document.createElement("div");
  guide.className = "castle-guide-dialogue";
  guide.id = "castle-guide-dialogue";
  guide.setAttribute("role", "dialog");
  guide.setAttribute("aria-modal", "false");
  guide.setAttribute("aria-label", "Castle steward introduction");
  guide.setAttribute("aria-hidden", "true");
  guide.hidden = true;

  const guideImage = document.createElement("img");
  guideImage.src = bubbleSrc;
  guideImage.width = 346;
  guideImage.height = 243;
  guideImage.alt = "";
  guideImage.draggable = false;
  guideImage.setAttribute("aria-hidden", "true");

  const guideContent = document.createElement("div");
  guideContent.className = "castle-guide-dialogue__content";
  const guideCopy = document.createElement("p");
  guideCopy.textContent = "Welcome to Yizcho Castle. The island's works, collector letters and archive live in these rooms. The ten houses below are being kept for the cats you will raise and grow with next.";
  const guideActions = document.createElement("div");
  guideActions.className = "castle-guide-dialogue__actions";
  const guideContinue = document.createElement("button");
  guideContinue.id = "castle-guide-continue";
  guideContinue.type = "button";
  guideContinue.textContent = "Continue";
  const guideArtist = document.createElement("button");
  guideArtist.id = "castle-guide-artist";
  guideArtist.type = "button";
  guideArtist.textContent = "Meet the artist";

  guideActions.append(guideContinue, guideArtist);
  guideContent.append(guideCopy, guideActions);
  guide.append(guideImage, guideContent);
  studioCanvas.append(studioImage, woodenCat, guide);
  castleStudioStage.append(studioAmbient, studioCanvas);
  castleStudioStage.style.setProperty("--castle-studio-ambient-image", `url("${studioSrc}")`);

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let guideTimer = 0;

  const clearGuideTimer = () => {
    if (!guideTimer) return;
    window.clearTimeout(guideTimer);
    guideTimer = 0;
  };

  const setGuide = (open, { focus = false } = {}) => {
    clearGuideTimer();
    const hidden = !open;
    const ariaHidden = open ? "false" : "true";
    const ariaExpanded = open ? "true" : "false";
    if (guide.hidden !== hidden) guide.hidden = hidden;
    if (guide.getAttribute("aria-hidden") !== ariaHidden) guide.setAttribute("aria-hidden", ariaHidden);
    if (woodenCat.getAttribute("aria-expanded") !== ariaExpanded) {
      woodenCat.setAttribute("aria-expanded", ariaExpanded);
    }
    if (open && focus) guideContinue.focus({ preventScroll: true });
  };

  const studioIsVisible = () => (
    !castleStudioStage.hidden &&
    document.body.classList.contains("castle-experience-open")
  );

  const scheduleGuide = () => {
    clearGuideTimer();
    guideTimer = window.setTimeout(() => {
      guideTimer = 0;
      if (studioIsVisible()) setGuide(true);
    }, reducedMotion.matches ? 120 : 420);
  };

  castleAbout?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    setGuide(false);
    castleEntryStage.scrollTop = 0;
    castleEntryStage.hidden = false;
    castleStudioStage.hidden = true;
    castleArtistStage.hidden = true;
    castleExperience.inert = false;
    castleExperience.setAttribute("aria-hidden", "false");
    castleAbout.setAttribute("aria-expanded", "true");
    if (castleBackLabel) castleBackLabel.textContent = "Back to the island";
    if (castleClose) castleClose.hidden = true;
    document.body.classList.add("castle-experience-open");
    window.requestAnimationFrame(() => castleDoor.focus({ preventScroll: true }));
  }, true);
  castleDoor.addEventListener("click", () => {
    castleStudioStage.scrollTop = 0;
    scheduleGuide();
  });
  woodenCat.addEventListener("click", () => setGuide(true, { focus: true }));
  guideContinue.addEventListener("click", () => {
    setGuide(false);
    woodenCat.focus({ preventScroll: true });
  });
  guideArtist.addEventListener("click", () => {
    setGuide(false);
    artistCompatibilityTrigger.click();
  });

  const dismissGuide = () => setGuide(false);
  castleBack?.addEventListener("click", dismissGuide);
  castleClose?.addEventListener("click", dismissGuide);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !guide.hidden) dismissGuide();
  });

  new MutationObserver(() => {
    if (!studioIsVisible() && !guide.hidden) setGuide(false);
  }).observe(castleExperience, {
    attributes: true,
    subtree: true,
    attributeFilter: ["class", "hidden"],
  });
})();
